export default __webpack_public_path__ + "static/media/clownfish.279690e0.png";